import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavCtx = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [favs, setFavs] = useState([]);
  const [products, setProducts] = useState([]);

  const refresh = () =>
    api.get("/favorites").then((r) => {
      setProducts(r.data);
      setFavs(r.data.map((p) => p.id));
    }).catch(() => {});

  useEffect(() => {
    if (user) {
      refresh();
    } else {
      setFavs([]);
      setProducts([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const toggle = async (productId) => {
    const { data } = await api.post(`/favorites/${productId}`);
    refresh();
    return data.favorited;
  };

  return <FavCtx.Provider value={{ favs, products, toggle }}>{children}</FavCtx.Provider>;
}

export const useFavorites = () => useContext(FavCtx);
